module.exports = {"driverJob":{"title":"Job List","navigate":"Navigate","start":"Start","end":"End","startCarMile":"Start Mile","endCarMile":"End Mile","fillDistanceStart":"Fill in form mile start","fillDistanceEnd":"Fill in form mile end","pleaseCheckConfirm":"Please check and confirm before returning the vehicle","checkMiles":"Check both the start and end miles of the car","km":"Km","qDrive":"Drive's Queue","orderItem":"Sort Queue by date time.","preparingDrive":"อยู่ในระหว่างการดำเนินการ","totalMile":"Total Mile","totalCost":"Total Cost","":""}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/driverJob.json
// module id = 716
// module chunks = 63